module.exports = __webpack_public_path__ + "static/media/Logo.ce43cb59.png";